<div theme>
    <div style="height: 100%;" class="align-text">
        <!-- <div class="progess-spinner-overlay" *ngIf="isLoaderEnabled">
            <div class="progess-spinner-center">
                <div class="loader">Loading...</div>
            </div>
            <div class="progess-spinner-center-text">
                Saving files might take a while. Do not refresh/reload the screen
            </div>
        </div> -->
    
        <div>
            <div class="title-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="zip-title" cdkFocusInitial>My Downloads</div>
                <button mat-button class="toolbar-icon-button" (click)="onCancel()">
                    <mat-icon class="material-icons dialog-closeicon">
                        close
                    </mat-icon>
                </button>
            </div>
        </div>
        <div class="zip-file-content-wrapper">
    
            <div class="history-card" *ngFor="let data of downloadfiles">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxFlex="55%" class="db-stack-trace-pills"
                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 68%;">
                        <!-- {{data.title}} - {{data.createdon |dateFormat}} - {{getTimeFromDate(data.createdon)}}  -->
                        {{data.title}}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="download-staatus-wrapper">
                        <!-- <div class="status-wrapper">{{data.module}}</div> -->
                        <div>
                            <div class="download-status-completed" *ngIf="data.status === 'Completed'">
                                <mat-icon class="material-symbols-outlined" matTooltip="Completed" [ngClass]="currentDisplayLanguage === 'ar' ? 'icon-placement' : ''">
                                    done 
                                </mat-icon>
                            </div>
                            <div class="download-status-pending" *ngIf="data.status === 'Pending' ">
                                <mat-icon class="pending-icon" matTooltip="Getting Generated">schedule</mat-icon>
                            </div>
                            <!-- <div class="module-wrapper download-status-failed"
                                *ngIf="data.status === 'Pending' && data.taskexecutionreport !== null && data.taskexecutionreport.includes('Download Failed')">
                                <mat-icon class="material-symbols-outlined" matTooltip="Failed">close</mat-icon>
                            </div> -->
                        </div>
    
    
                        <button mat-button class="toolbar-icon-button" [matMenuTriggerFor]="zipMoreBtn">
                            <mat-icon class="material-icons">
                                more_vert
                            </mat-icon>
                        </button>
                        <mat-menu #zipMoreBtn="matMenu" class="my-download-menu">
                            <div fxLayout="column">
                                <button mat-button class="more-expand" (click)="archieveDownload(data)">
                                    Download
                                </button>
                                <!-- <button mat-button class="more-expand">
                                    Delete
                                </button> -->
                            </div>
                        </mat-menu>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="mention-date">{{data.createdon |
                        dateFormat}}</div>
                    <div class="mention-date">{{getTimeFromDate(data.createdon)}}</div>
                </div>
            </div>
    
    
        </div>
        <div class="notification-no-data-div no-data-wrapper" fxLayout="row" fxLayoutAlign="center center"
            style="height: 49vh; top: -15px !important;" *ngIf="downloadfiles.length === 0">
            <div fxLayout="column" fxLayoutAlign="center center">
                <div class="no-data-div-bottom">
                    <mat-icon class="fas fa-search no-data-found-icon"></mat-icon>
                </div>
                <div>
                    <span class="no-dataAvailable">No Downloads</span>
                </div>
            </div>
        </div>
    </div>
</div>
